/**
 * Подзаголовки на вкладке «Пульты и аксессуары» и в админке — один источник порядка.
 */
export const ACCESSORY_VITRINE_SECTION_ORDER = [
  'Пульты управления',
  'Хабы и контроллеры',
  'Датчики и интерфейсы',
  'Аксессуары и контроллеры',
  'Без секции',
] as const;

export type AccessoryVitrineSection = (typeof ACCESSORY_VITRINE_SECTION_ORDER)[number];

export function compareAccessoryVitrineSections(a: string, b: string): number {
  const ia = (ACCESSORY_VITRINE_SECTION_ORDER as readonly string[]).indexOf(a);
  const ib = (ACCESSORY_VITRINE_SECTION_ORDER as readonly string[]).indexOf(b);
  const ra = ia === -1 ? 1000 : ia;
  const rb = ib === -1 ? 1000 : ib;
  if (ra !== rb) return ra - rb;
  return a.localeCompare(b, 'ru');
}
